// use client downloaded from CDN
export const sentryClient = window.Sentry;
